import React from 'react'

const ProfileSectionSP = ({ section }) => {
  if (!section.additional) {
    return null
  }

  return (
    <div className="assessment-section">
      <p>
        The scores below are a summary of this person's skills; higher numbers represent
        higher attainment levels.
      </p>
      <ul className="assessment">
        {section.additional.map(r => (
          <li key={r.elementId}>
            <b>{r.elementName}</b> <span>{r.value.toFixed(2)}</span>
          </li>
        ))}
      </ul>
      <p>
        For more information about these scores, please visit the{' '}
        <a href="/skills">Skills Profiler</a>.
      </p>
    </div>
  )
}

export default ProfileSectionSP
